import React from 'react';
import ModalComponent from '../../../../../../components/modal/index';
import FieldComponent from '../../../../../../components/field/index';
import diagnostics from '../../../../../../services/diagnostics';

export default class AddDiagnosticModal extends React.Component {
    state = {}

    static getDerivedStateFromProps(nextProps, prevState) {
        let errors = {
            name: ""
        }
        if(nextProps.diagnostic) {
            let fields = Object.assign({}, this.props.diagnostic)
            return {fields: fields, errors: errors}
        } else
            return {fields: errors, errors: errors}
    }

    hasError = () => {
        let errors = Object.assign({},this.state.errors);
        let hasError = false;
        if(!this.state.fields.name) {
            errors.name = "Porfavor introduzca un nombre";
            hasError = true;
        }
        this.setState({errors: errors});
        return hasError;
    }

    submit = (e) => {
        e.preventDefault()
        if(!this.hasError()) {
            diagnostics.insert({
                ...this.state.fields,
                status: "activo"
            }, (err, diagnostic) => {
                this.props.add(diagnostic)
            });
        }
    }

    onInputChange = (e) => {
        let {name, value} = e.target;
        let newFields = Object.assign({}, this.state.fields);
        let newErrors = Object.assign({}, this.state.errors)
        newFields[name] = value;
        newErrors[name] = "";
        this.setState({fields: newFields, errors: newErrors})
    }

    render() {
        return (
            <ModalComponent {...this.props} hasClose={true} >
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">Crear servicio</p>
                    </header>
                    <section className="modal-card-body">
                        <form id="form" onSubmit={this.submit}>
                            <FieldComponent label="Nombre *" icon="keyboard"
                                value={this.state.fields.name} name="name"
                                error={this.state.errors.name}
                                onInputChange={this.onInputChange}
                            />
                        </form>
                    </section>
                    <footer className="modal-card-foot">
                        <button className="button is-success" form="form" type="submit">
                            Agregar
                        </button>
                    </footer>
                </div>
            </ModalComponent>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/diagnostics/components/add-diagnostic/index.js